import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID_FUTURE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            DOCUMENT_CONFIGS.LOSS_OF_MEC_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_MEC
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_MEDICAID,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TERM_LETTER_FROM_GOV_PROVIDER
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_EMPLOYER_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                    DOCUMENT_CONFIGS.EMPLYR_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.HEALTH_INSURANCE_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.GOVT_INSURANCE_COVERAGE_OFFER
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.MARRIAGE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_MARRIAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.MARRIAGE_CERTIFICATE
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_COVERAGE_PRIOR_MARRIAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DOC_PREMIUM_PAID,
                    DOCUMENT_CONFIGS.HIPPA_CERTIFICATION,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.TERM_LETTER_COV,
                    DOCUMENT_CONFIGS.OTHER_COVERAGE_DOC
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.BIRTH
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_BIRTH_ADOPTION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.BIRTH_CERTIFICATE,
                    DOCUMENT_CONFIGS.COURT_ORDER_INDICATING_ADD_REMOVE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.GAIN_COURT_APPOINTED_DEPENDENT
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_GAIN_OF_DEPENDENT,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.COURT_ORDER_FOSTER_CARE,
                    DOCUMENT_CONFIGS.COURT_ORDER_INDICATING_ADD_REMOVE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_CITIZENSHIP,
            DOCUMENT_CONFIGS.CHANGE_IN_LEGAL_PRESENCE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_CURRENT_LEGAL_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DOC_INDICATING_LEGAL_STATUS
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_INCARCERATION,
            DOCUMENT_CONFIGS.INCARCERATION
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCARCERATION_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.COURT_ORDER_INCARCERATION
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS,
            DOCUMENT_CONFIGS.MOVED_INTO_STATE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.ADDRESS_PROOF_DATE_MOVE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CURRENT_LEASE,
                    DOCUMENT_CONFIGS.MORTGAGE_DOCUMENT,
                    DOCUMENT_CONFIGS.UTILITY_BILLS,
                    DOCUMENT_CONFIGS.DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                    DOCUMENT_CONFIGS.SCHOOL_ENROLLMENT_NEW_ADDRESS
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.ADDRESS_PROOF_PREVIOUS_ADDRESS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.PREVIOUS_LEASE,
                    DOCUMENT_CONFIGS.PREVIOUS_MORTGAGE_DOCUMENT,
                    DOCUMENT_CONFIGS.PREVIOUS_DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.SCHOOL_ENROLLMENT_ADDRESS,
                    DOCUMENT_CONFIGS.PREVIOUS_UTILITY_BILLS,
                    DOCUMENT_CONFIGS.PREVIOUS_VOTER_CARD
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TERM_LETTER_COV,
                    DOCUMENT_CONFIGS.DOC_PREMIUM_PAID,
                    DOCUMENT_CONFIGS.HIPPA_CERTIFICATION,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.OTHER_COVERAGE_DOC
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.HRA,
            DOCUMENT_CONFIGS.QSEHRA_SEP,
            DOCUMENT_CONFIGS.QSEHRA_SEP_FUTURE,
            DOCUMENT_CONFIGS.ICHRA_SEP,
            DOCUMENT_CONFIGS.ICHRA_SEP_FUTURE,
            DOCUMENT_CONFIGS.HRA_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_HRA,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.HRA_EMPLOYER_NOTICE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_EMPLOYER_CONTRIBUTION_TO_COBRA,
            DOCUMENT_CONFIGS.LOSS_OF_EMPLOYER_CONTRIBUTION_TO_COBRA_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_EMPLOYER_CONTRIBUTION_TO_COBRA,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.EMPLYR_COVERAGE_OFFER_COBRA,
                    DOCUMENT_CONFIGS.LETTER_EMPLYR_COBRA,
                    DOCUMENT_CONFIGS.COBRA_THIRD_PARTY_COV
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.NEWLY_ELIGIBLE_FOR_APTC_CSR_DUE_TO_CHANGES_IN_CURRENT_EMPLOYER_PLAN,
            DOCUMENT_CONFIGS.NEWLY_ELIGIBLE_FOR_APTC_CSR_DUE_TO_CHANGES_IN_CURRENT_EMPLOYER_PLAN_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EMP_BENEFITS_CHANGES,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.LETTER_EMPLOYER_COVERAGE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.NEWLY_ELIGIBLE_FOR_APTC_CSR_DUE_TO_INCOME_DECREASE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCOME_EMPLOYER,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.EMPLYR_NOTICE_INCOME_DEC,
                    DOCUMENT_CONFIGS.PAY_STUB_DECREASE,
                    DOCUMENT_CONFIGS.SELF_EMPLOYED_GCI_DOC
                ]
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_PRIOR_COVERAGE_INCOME_CHANGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TERM_LETTER_COV,
                    DOCUMENT_CONFIGS.DOC_PREMIUM_PAID,
                    DOCUMENT_CONFIGS.HIPPA_CERTIFICATION,
                    DOCUMENT_CONFIGS.PAY_STUB_COV,
                    DOCUMENT_CONFIGS.OTHER_COVERAGE_DOC
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.DENIED_MEDICAID_CHIP_APPLIED_IN_OE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_MEDICAID_DENIAL_OEP,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.SELF_ATTESTED_FORM_MEDICAID_DENIAL
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.ERROR_BY_MARKETPLACE_OR_MARKETPLACE_PARTNER,
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_EXCEPTIONS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.SELF_ATTESTED_FORM_EXCEPTION,
                    DOCUMENT_CONFIGS.ADDITIONAL_DOC_EXCEPTION
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.EMPLOYER_SPONSORED_COVERAGE_AFFORDABLE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.EMPLOYER_HEALTH_PLAN_NOTICE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_PRIOR_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.EMPLOYER_HEALTH_PLAN_NOTICE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.OTHER_ELIGIBILITY_CHANGE_HEALTH_STATUS_CHANGE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_ELIGIBILITY_HEALTH_COVERAGE_STATUS_CHANGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.ELIGIBILITY_HEALTH_STATUS_CHANGE_DOC,
                    DOCUMENT_CONFIGS.SELF_ATTESTED_FORM_EXCEPTION
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.UNSUPPORTED_EVENT
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_PROVING_EVENT,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT,
                    DOCUMENT_CONFIGS.SELF_ATTESTED_FORM_EXCEPTION
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.DIVORCE,
            DOCUMENT_CONFIGS.DIVORCE_OR_ANULLMENT
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_DIVORCE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DIVORCE_DECREE
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.LEGAL_SEPARATION
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.LEGAL_SEPARATION_DOC,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.COURT_ORDER_LEGAL_SEPARATION
                ]
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.PREGNANT
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_PREGNANCY,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT,
                    DOCUMENT_CONFIGS.SELF_ATTESTED_FORM_EXCEPTION
                ]
            }
        ]
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_AI_AN_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AMERICAN_INDIAN_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AI_AN,
            DOCUMENT_CONFIGS.CHANGE_IN_TRIBE_STATUS
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_TRIBAL_AFFILIATION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TRIBAL_CARD,
                    DOCUMENT_CONFIGS.CERT_CDIB,
                    DOCUMENT_CONFIGS.BIA_CERTIFICATION,
                    DOCUMENT_CONFIGS.TRIBAL_DOCUMENT,
                    DOCUMENT_CONFIGS.ANCSA_SHAREHOLDER_DOCUMENT,
                    DOCUMENT_CONFIGS.I872,
                    DOCUMENT_CONFIGS.LETTER_OF_EXPLANATION
                ]
            }
        ]
    }
];
